/**
 * 活动处理的工具类
 */

var campKit = (function () {

  /**
   * 活动状态
   * @type {{}}
   */
  var campStatus = {
    D : "D", //草稿
    W : "W" //待审批
  };

  /**
   * 提交标记
   * @type {{}}
   */
  var submitFlag = {
    pass : 1, //审批通过
    refuse : 2, //审批拒绝
  };

  return {
    campStatus : campStatus,
    submitFlag : submitFlag,

    /**
     * 判断是否是草稿状态
     */
    isDraft : function (status) {
      return campStatus.D == status;
    },
    /**
     * 判断是否是提交待审核状态
     */
    isSubmit : function (status) {
      return campStatus.W == status;
    },

    /**
     * 判断是否是审批通过
     * @param flag
     * @returns {boolean}
     */
    isPass : function (flag) {
      return submitFlag.pass == flag;
    }
  };
})();

export default campKit;



// WEBPACK FOOTER //
// ./src/common/campKit.js